export default __webpack_public_path__ + "static/media/Clean Up.24555ff4.png";